import { useState, FC } from 'react';

import postalCodeRegex from '@eneco/common/validation/postalCodeRegex';
import PostalCodeInput from '@eneco/components/PostalCodeInput/PostalCodeInput';
import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import { useProductsPublicGetInterruptions } from '@eneco/dc/hooks';
import { Box, Button, Form, Stack, TextLink } from '@eneco/sparky';
import { ResponseModels_Products_Interruption_InterruptionModel } from '@monorepo-types/dc';
import { Placeholder , wrap } from '@sitecore/common';
import type { WarmthInterruptionsRendering } from '@sitecore/types/manual/WarmthInterruptions';

import { WarmthInterruptionsDialog } from './WarmthInterruptionsDialog';

export const WarmthInterruptions: FC<WarmthInterruptionsRendering> = ({ fields }) => {
  const { data } = useProductsPublicGetInterruptions();
  const [filteredData, setFilteredData] =
    useState<ResponseModels_Products_Interruption_InterruptionModel['data']>(null);
  const [postalCode, setPostalCode] = useState<string>();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [error, setError] = useState<string>();
  const {
    dialogInterruptionsTitle,
    dialogInterruptionsNearByTitle,
    viewAllInterruptionsLinkText,
    submitButtonText,
    postalCodeFormField,
  } = fields ?? {};

  const filterData = () => {
    if (!!postalCode && postalCodeRegex.test(postalCode)) {
      setFilteredData(data?.filter(item => item.address?.postalCode === postalCode));
      setError(undefined);
      setDialogOpen(true);
    } else {
      setDialogOpen(false);
      setError(postalCodeFormField?.value?.validationMessage);
    }
  };

  return (
    <Box backgroundColor="backgroundSecondary" borderRadius="m" padding="6">
      <Stack gap="6">
        <Placeholder name="jss-interruptions-intro" />
        <Form
          onSubmit={event => {
            event.preventDefault();
            filterData();
          }}>
          <PostalCodeInput
            name="postal-code"
            label={postalCodeFormField?.value?.label}
            hint={postalCodeFormField?.value?.hint}
            placeholder={postalCodeFormField?.value?.placeholder}
            value={postalCode}
            onChange={setPostalCode as (...event: unknown[]) => void}
            error={error}
          />
        </Form>
        <Stack.Item shrink>
          <Button onClick={filterData}>{wrap(submitButtonText)}</Button>
          <TrackedDialog isOpen={isDialogOpen} setOpen={setDialogOpen} title={wrap(dialogInterruptionsNearByTitle)}>
            <WarmthInterruptionsDialog interruptions={filteredData} fields={fields} />
          </TrackedDialog>
        </Stack.Item>
        <Stack.Item shrink>
          <TrackedDialog
            title={wrap(dialogInterruptionsTitle)}
            trigger={<TextLink emphasis="high">{wrap(viewAllInterruptionsLinkText)}</TextLink>}>
            <WarmthInterruptionsDialog interruptions={data} fields={fields} />
          </TrackedDialog>
        </Stack.Item>
      </Stack>
    </Box>
  );
};

export default WarmthInterruptions;
